module.exports = __webpack_public_path__ + "fonts/font_IE9.3d2483c7.eot";